"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolListError = exports.SymbolList = void 0;
class SymbolList {
    constructor(obj) {
        this.symbols = obj;
    }
}
exports.SymbolList = SymbolList;
class SymbolListError {
    constructor(obj) {
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.SymbolListError = SymbolListError;
//# sourceMappingURL=SymbolList.js.map